export enum SITE_TYPE {
    FRUIT = 'fruit',
    PLANT = 'plant',
    BOTH = 'both'
};